
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 55.562 39.687","height":"150","width":"210"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#f5f5f5"}},[_c('path',{attrs:{"d":"M1.323 1.654H54.24V9.47H1.323M1.323 15.973H54.24v7.78H1.323M1.323 30.22H54.24v7.813H1.323"}})])])
          )
        }
      }
    